import { SetError } from './../actions/package-visualizer.actions';
import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { DeploymentService } from '../../core/services/deployment.service';

import { map, switchMap, catchError, withLatestFrom, filter } from "rxjs/operators";
import { of } from 'rxjs';
import {
  GetPackageSummary,
  EPackageSummaryActions,
  GetPackageSummarySuccess,
  SetSelectedCatalogObjects,
  GetDependencies,
  GetDependenciesSuccess
} from '../actions/package-visualizer.actions';
import { Store, select } from '@ngrx/store';
import { SelectedPackageId } from '../selectors/package-visualizer.selectors';
import { UploadBexFileEffects } from "./upload-bex.effects";
import { getCurrentBexFile } from "../selectors/upload-bex.selectors";
import { DatePipe } from "@angular/common";
import { DecryptModalComponent } from "app/deployment/decrypt-modal/decrypt-modal.component";
import { BzgModalService } from "bz-genome-angular";
import { IAppState } from 'app/IAppState';
@Injectable()
export class PackageVisualizerEffects {
  getDependencies$ = createEffect(() =>
    this._actions$.pipe(
      ofType<GetPackageSummary>(EPackageSummaryActions.GetPackageSummary),
      switchMap(async (action) => {
        const catalogObjectId = action.payload.packageId.toString();
        const bexName = action.payload.packageName;
        const response = await this._deploymentService.checkBexEncrypt(catalogObjectId).toPromise();
        let result = !response;

        if (!result) {
          result = await UploadBexFileEffects.showModalDecryptBex({
            fileName: bexName,
            id: catalogObjectId
          });
        }

        if (result) {
          return await this._deploymentService.getPackageSummary(catalogObjectId).toPromise();
        }
        else {
          this._store.dispatch(new SetError(true));
          return null
        }

      }),
      filter(result => result !== null),
      switchMap((tree: IPackageSummary) =>
        [new GetPackageSummarySuccess(tree), new SetSelectedCatalogObjects()]
      ),
      catchError((err, caught) => {
        this._store.dispatch(new SetError(true));
        return caught;
      })
    )
  );
  packageSummary$ = createEffect(() =>
    this._actions$.pipe(
      ofType<GetDependencies>(EPackageSummaryActions.GetDependencies),
      withLatestFrom(this._store.pipe(select(SelectedPackageId))),
      map(([action, packageId]) => ({ packageId, catalogObjectId: action.payload })),
      switchMap((data) =>
        this._deploymentService.getPackageVisualizerDependencies(data.packageId, data.catalogObjectId)
      ),
      switchMap((dependencies: IPackageDependencies) =>
        [new GetDependenciesSuccess(dependencies)]
      )
    )
  );

  constructor(
    private _deploymentService: DeploymentService,
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private datePipe: DatePipe,
    private modalService: BzgModalService
  ) {
  }
}
